module.exports = __webpack_public_path__ + "img/hinamori_main.323616a5.jpg";